import script from "./SecondPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondPage.vue?vue&type=style&index=0&id=a26de38a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a26de38a"]])

export default __exports__